import { render } from "./SettingActivity.vue?vue&type=template&id=eb8c6f56"
import script from "./SettingActivity.vue?vue&type=script&lang=js"
export * from "./SettingActivity.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__